import { useEffect, useState } from 'react'

/** True while the media query matches; re-renders when it flips. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false))
  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])
  return matches
}

/** Below this the dock is hidden and the board shows one day at a time. */
export const NARROW = '(max-width: 1023px)'
/** Phones: the bottom tab bar replaces the top tabs. */
export const PHONE = '(max-width: 767px)'
